import React, { Component } from 'react';
import { push } from 'connected-react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import { toggleMobileNav } from 'services/layout/duck';
import { destroyCurrentUserSession } from 'services/users/duck';
import { get } from 'lodash';
import Header from 'components/organisms/Header';

class HeaderContainer extends Component {
    homeClick = () => {
        window.scrollTo(0, 0);
        const landingPage = this.props.landingPage;
        const location = get(this.props, 'location', '');

        if (this.props.isOkta) {
            if (location.startsWith('/dashboard')) {
                this.props.push('/dashboard');
            } else if (location.startsWith('/admin')) {
                this.props.push('/admin');
            } else {
                this.props.push('/');
            }
        } else if (landingPage) {
            this.props.push(landingPage);
        }
    }

    render() {
        return <Header
            key={2}
            admin={this.props.admin}
            hideLinks={this.props.hideLinks}
            hideHamburgerMenu={this.props.hideHamburgerMenu}
            borderColor={this.props.borderColor}
            homeClick={this.homeClick}
            isOkta={this.props.isOkta}
            mobileNavExpanded={this.props.mobileNavExpanded}
            toggleMobileNav={this.props.toggleMobileNav}
            contactEmail={this.props.contactEmail}
            currentUserName={this.props.currentUser.firstName || ''}
            currentUserEmail={this.props.currentUser.email || ''}
            doLogout={this.props.destroyCurrentUserSession}
            entityBranding={this.props.entityBranding}
            brandBranding={this.props.brandBranding}
            currentUserScope={this.props.currentUser.scope || []}
            enrollmentSite={this.props.enrollmentSite}>
            {this.props.children}
        </Header>;
    }
}

const mapStateToProps = (state) => {
    // Prefer entity branding, but fall back to user branding if it exists. Otherwise, empty object.
    const brandBranding = get(
        state,
        'entities.meta.brandBranding',
        get(state, 'users.currentUser.brand.branding', {})
    );

    return {
        landingPage: state.users.currentUser ? state.users.currentUser.landingPage : '/dashboard',
        isOkta: state.users.currentUser ? state.users.currentUser.isOkta : false,
        mobileNavExpanded: state.layout.mobileNavExpanded,
        entityBranding: state.entities.meta.entityBranding,
        contactEmail: state.entities.meta.contactEmail,
        enrollmentSite: state.entities.meta.enrollmentSite,
        location: state.router.location.pathname,
        currentUser: state.users.currentUser || {},
        brandBranding
    };
};

export default compose(
    withTheme,
    connect(mapStateToProps, { toggleMobileNav, push, destroyCurrentUserSession })
)(HeaderContainer);



// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.js